import { useContext } from 'react';
import {
    ActionDependant,
    GlobalDataContext,
    propsDataLocationToPathAndValue,
    TemplateContext,
} from '@ea-lab/reactive-json';
import { ComplexityDots } from './complexity-dots';

/**
 * ComplexityDotsField — editable complexity selector for reactive-json forms.
 *
 * Renders the SAME widget as the kanban cards (5 coloured dots, green→red,
 * level 0-5, click a dot to set, click the active level to clear) but bound via
 * dataLocation like the other field components (PriorityIconField, StarRating…).
 *
 * Props:
 *   dataLocation – standard reactive-json form binding (stores the 0-5 level)
 *   size         – dot diameter in px (default 14)
 *   readOnly     – disables interaction (default false)
 */
export const ComplexityDotsField = ({ props, datafield, path }) => {
    const globalDataContext = useContext(GlobalDataContext);
    const templateContext = useContext(TemplateContext);

    const { formData, formDataPath } = propsDataLocationToPathAndValue({
        currentPath: path,
        datafield,
        dataLocation: props.dataLocation,
        defaultValue: 0,
        globalDataContext,
        templateContext,
    });

    const size = props.size ?? 14;
    const readOnly = props.readOnly ?? false;
    const level = Number(formData) || 0;

    const handleChange = (next) => {
        if (readOnly || !globalDataContext?.updateData) return;
        globalDataContext.updateData(next, formDataPath);
    };

    return (
        <ActionDependant {...props}>
            <div className="inline-flex items-center h-[42px] px-1">
                <ComplexityDots value={level} onChange={handleChange} size={size} readOnly={readOnly} />
            </div>
        </ActionDependant>
    );
};

export default ComplexityDotsField;
